import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptainChecklistRoutingModule } from './captain-checklist-routing.module';
import { CaptainChecklistComponent } from './captain-checklist.component';
import { MatCardModule } from '@angular/material/card';
import { LoadingModule } from '../../../../shared/loading/loading.module';
import { ImageCarouselModule } from '../../../../shared/image-carousel/image-carousel.module';

@NgModule({
  declarations: [CaptainChecklistComponent],
  imports: [
    CommonModule,
    CaptainChecklistRoutingModule,
    MatCardModule,
    LoadingModule,
    ImageCarouselModule,
  ],
  exports: [CaptainChecklistComponent],
})
export class CaptainChecklistModule {}
